var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _mask, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintVegan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.2069 66.4228C103.252 72.4719 105.609 80.7854 104.345 88.625C96.509 89.8751 88.1943 87.4998 82.1493 81.4507C76.1207 75.4031 73.7633 67.0896 75.0277 59.25C82.8635 57.9999 91.1782 60.3752 97.2232 66.4243L97.2069 66.4228Z",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0273 59.248L104.361 88.6244",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.349 68.057C108.321 72.9293 104.517 80.6881 104.361 88.6275C111.848 91.2569 120.453 90.4047 127.481 85.5324C134.509 80.6601 138.313 72.9013 138.469 64.9619C130.983 62.3325 122.377 63.1847 115.349 68.057V68.057Z",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.453 64.9584L104.361 88.6255",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.756 62.7676L105.068 81.5132",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.653 52.378C121.941 59.0856 114.393 62.6129 106.762 62.5011C104.068 55.3733 104.831 47.0778 109.559 40.3717C114.289 33.6493 121.82 30.1205 129.451 30.2323C132.146 37.36 131.383 45.6556 126.654 52.3617L126.653 52.378Z",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.778 62.5033L129.451 30.233",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.593 41.634C108.405 41.1571 108.202 40.6787 107.997 40.2165C104.543 32.7738 97.7459 27.9552 90.2338 26.7039C86.31 33.2359 85.5795 41.5344 89.0341 48.9771C92.4724 56.4184 99.269 61.2369 106.797 62.4898",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.78 62.5039L90.2344 26.7031",
    stroke: "white",
    strokeWidth: 4.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5872 44.4533C37.7233 39.1133 41.6996 35.1507 43.788 33.3495C44.5002 32.7638 45.5259 32.9948 45.9316 33.8074C47.1149 36.3204 49.0668 41.5682 47.9201 46.8809C46.7799 52.1288 42.9502 56.0663 40.8345 57.878",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1985 51.1513C20.8585 50.0151 15.6108 51.967 13.1249 53.1399C12.3019 53.5183 12.0814 54.5712 12.6671 55.2834C14.4683 57.3719 18.4309 61.3481 23.7708 62.4843C29.0186 63.6246 34.168 61.7417 36.7187 60.5752",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2958 44.7462C39.2112 49.2493 39.2641 54.7576 39.0571 57.5544C38.9999 58.5447 37.9946 59.1804 37.0841 58.8428C34.4385 57.8905 29.4782 55.5466 26.5628 51.0435C23.616 46.4587 23.5862 40.8479 23.8141 38.1055C23.9027 37.197 24.7991 36.603 25.6447 36.9343C28.2527 37.8698 33.3322 40.1991 36.3062 44.7735L36.2958 44.7462Z",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7941 57.6083C40.0271 58.617 36.5189 60.8695 33.996 64.3055C28.2712 72.0939 30.2715 83.164 37.7457 89.2905L69.7243 115.559C73.0011 118.237 77.7827 115.152 76.6863 111.075L65.7389 70.2681C63.1701 60.7281 53.3718 55.0564 43.7941 57.6083V57.6083Z",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0592 103.239L66.2395 101.84",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.228 94.9575L59.5836 91.4962",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1154 86.8447L52.9079 81.1895",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8412 76.926L46.2516 70.8463",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1_113_2220",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8643 96.5239C19.8476 92.1674 23.1544 88 27.628 88H142.69C147.164 88 150.471 92.1674 149.454 96.5239L148.694 99.778C141.803 129.305 115.479 150.193 85.1591 150.193V150.193C54.839 150.193 28.5149 129.305 21.6238 99.778L20.8643 96.5239Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8643 96.5239C19.8476 92.1674 23.1544 88 27.628 88H142.69C147.164 88 150.471 92.1674 149.454 96.5239L148.694 99.778C141.803 129.305 115.479 150.193 85.1591 150.193V150.193C54.839 150.193 28.5149 129.305 21.6238 99.778L20.8643 96.5239Z",
    fill: "#5D38E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.694 99.778L142.462 98.3234L148.694 99.778ZM149.454 96.5239L155.686 97.9785L149.454 96.5239ZM27.628 94.4H142.69V81.6H27.628V94.4ZM143.221 95.0693L142.462 98.3234L154.927 101.233L155.686 97.9785L143.221 95.0693ZM27.8563 98.3234L27.0969 95.0693L14.6318 97.9785L15.3913 101.233L27.8563 98.3234ZM85.1591 143.793C57.8133 143.793 34.0714 124.954 27.8563 98.3234L15.3913 101.233C22.9583 133.656 51.8647 156.593 85.1591 156.593V143.793ZM142.462 98.3234C136.247 124.954 112.505 143.793 85.1591 143.793V156.593C118.454 156.593 147.36 133.656 154.927 101.233L142.462 98.3234ZM142.69 94.4C143.042 94.4 143.301 94.7272 143.221 95.0693L155.686 97.9785C157.64 89.6076 151.286 81.6 142.69 81.6V94.4ZM27.628 81.6C19.0322 81.6 12.6782 89.6076 14.6318 97.9785L27.0969 95.0693C27.017 94.7273 27.2767 94.4 27.628 94.4V81.6Z",
    fill: "white",
    mask: "url(#path-18-inside-1_113_2220)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9216 137.082C73.7171 138.08 68.2016 137.573 63.0625 135.38",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9177 114.35C76.7934 121.551 76.3351 129.833 78.921 137.066C86.466 135.61 93.3726 131.027 97.497 123.826C101.621 116.625 102.08 108.343 99.4937 101.109C91.9487 102.566 85.0421 107.149 80.9177 114.35Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9219 137.067L99.4945 101.094",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintVegan);
export default __webpack_public_path__ + "static/media/footprint_vegan.ff21bdbc64e6741777d88ade214fb573.svg";
export { ForwardRef as ReactComponent };